import React, { useContext } from "react"
import { css } from "@emotion/core"
import { useTheme } from "emotion-theming"
import Context from "../store/context"
import Layout from "../components/Layout"
import Toggle from "../components/Toggle"

const IndexPage = () => {
  const { state } = useContext(Context)

  const theme = useTheme()

  return (
    <Layout>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;

          h1 {
            font-size: 95px;
            text-transform: uppercase;
            text-align: center;
          }
        `}
      >
        <h1>Dark Mode Toggle</h1>
        <Toggle />
      </div>
    </Layout>
  )
}

export default IndexPage
